import config from './config.json' 
import dSlide1 from './dSlide1.json' 
export const cfg =  config;
export const dSld001 =  dSlide1;